import { createApp } from 'vue'
import App from './App.vue'
import { useI18n } from './i18n.js'

const params = new URLSearchParams(window.location.search)
const embedMode = params.get('embed') === '1'

// Embed mode honors the widget's data-language (passed via ?lang=…); the
// existing detection runs against navigator.language otherwise.
const langParam = params.get('lang')
if (langParam) {
  const { locale } = useI18n()
  locale.value = langParam.substring(0, 2).toLowerCase()
}

createApp(App, { embedMode }).mount('#app')

// Skip the service worker inside the embed iframe — it's hosted under the
// chat origin (not the host page's), so registering it would conflict and
// add no value for the embedded chat.
if ('serviceWorker' in navigator && !embedMode) {
  window.addEventListener('load', () => {
    const base = import.meta.env.BASE_URL
    navigator.serviceWorker
      .register(`${base}sw.js`, { scope: base })
      .catch((err) => console.warn('SW registration failed:', err))
  })
}
